// Administration officials data for Rayalaseema University
export const administrationData = {
  rector: {
    id: "rector_001",
    name: "Dr. N.T.K. Naik M.A., Ph.D",
    designation: "Rector",
    fullDesignation: "Rector, Rayalaseema University",
    image: "/person/RECTOR_NAIK.JPG",
    alt: "University Rector",
    office: "Office of the Rector",
    email: "rector@ruk.ac.in",
    phone: "08518-200000",
    qualifications: "M.A., Ph.D",
    department: "Administration"
  },
  registrar: {
    id: "registrar_001",
    name: "Dr.B.Vijaya Kumar Naidu",
    designation: "Registrar",
    fullDesignation: "Registrar, Rayalaseema University",
    image: "/person/registrar-Vijay.JPG",
    alt: "University Registrar",
    office: "Office of the Registrar",
    email: "registrar@ruk.ac.in",
    phone: "08518-200001",
    qualifications: "Ph.D",
    department: "Administration"
  },
  collegeDevelopment: {
    id: "college_dev_001",
    name: "Prof. Venkata Sundaranand Putcha, M.Sc., Ph.D.",
    designation: "Professor",
    fullDesignation: "Professor, Rayalaseema University",
    image: "/person/putcha.JPG",
    alt: "Dean Of College Development cell",
    office: "Dean Of College Development cell",
    email: "anand_putcha@yahoo.com",
    phone: "9848226855",
    qualifications: "M.Sc., Ph.D.",
    department: "College Development"
  },
  academicAffairs: {
    id: "academic_affairs_001",
    name: "Dr. Bharath Kumar Ravuru M.Sc., Ph.D.",
    designation: "Dean Of Academic Affairs",
    fullDesignation: "Professor and Head of Botany",
    image: "/person/bharath.png",
    alt: "Dean Of Academic Affairs",
    office: "Dean Of Academic Affairs",
    email: "drbharathravuru@gmail.com",
    phone: "8500722075",
    qualifications: "M.Sc., Ph.D.",
    department: "Academic Affairs"
  }
};

export default administrationData;